















import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { BookingV1DealPartialUpdateRequest } from '@/requests/mainApi'
import UiModal from '@/components/ui/UiModal.vue'
import UiButton from '@/components/ui/UiButton.vue'
import { storeModuleName as uiStoreModule } from '@/store/modules/ui'
import { storeModuleName as profileStoreModule } from '@/views/App/Profile/store'

interface Data {}

interface Methods {
  setStateDutyModalStatus: (value: boolean) => void
  updateDeal: (payload: BookingV1DealPartialUpdateRequest) => Promise<void>
}

interface Computed {
  refModal: any
}

interface Props {}

export default Vue.extend({
  name: 'UiConsultationModal',
  components: {
    UiModal,
    UiButton
  },
  props: {},
  computed: {
    refModal () {
      return (this.$refs as any).modal
    },
    ...mapGetters(uiStoreModule, ['stateDutyModalStatus'])
  },
  watch: {
    stateDutyModalStatus (val: boolean) {
      if (val) {
        this.refModal.open()
      }
    }
  },
  methods: {
    onModalClose () {
      this.setStateDutyModalStatus(false)
    },
    async confirmStateDutyPayment () {
      await this.updateDeal({
        data: {
          dutyPaid: true
        }
      })
      this.refModal.close()
    },
    ...mapMutations(uiStoreModule, ['setStateDutyModalStatus']),
    ...mapActions(profileStoreModule, ['updateDeal'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
